import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Lottie from 'react-lottie';
import qs from 'query-string';
import { SHOW_TOAST_MESSAGE, useAppContext } from 'use-app';
import styles from './index.module.sass';
import Carousel from 'components/carousel';
import Card from 'components/card';
import Video from 'components/video';
import refuelingTutorial01 from 'lottie/tutorial_refueling_01.json';
import refuelingTutorial02 from 'lottie/tutorial_refueling_02.json';
import refuelingTutorial03 from 'lottie/tutorial_refueling_03.json';
import refuelingPassTutorial01 from 'lottie/tutorial_pass_01.json';
import refuelingPassTutorial02 from 'lottie/tutorial_pass_02.json';
import refuelingPassTutorial03 from 'lottie/tutorial_pass_03.json';
import parkingTutorial01 from 'lottie/tutorial_parking_01.json';
import parkingTutorial02 from 'lottie/tutorial_parking_02.json';
import parkingTutorial03 from 'lottie/tutorial_parking_03.json';
import iconTutorial01 from 'assets/icon_tutorial_01.svg';
import iconTutorial02 from 'assets/icon_tutorial_02.svg';
import iconTutorial03 from 'assets/icon_tutorial_03.svg';
import iconTutorial04 from 'assets/icon_tutorial_04.svg';
import iconCheck from 'assets/icon_check.svg';
import iconArrow from 'assets/icon_cad_arrow.svg';
import { ReactComponent as IconScanPay } from 'assets/main-scan-payment.svg';
import { distributorName, isCpcpay, isNpcpay, isCathaymr, PATH } from 'config';
import classnames from 'classnames/bind';
import amplitude from 'service/amplitude';
import { getLoginState } from 'model/user';
import { getUserInfo } from 'helpers/data-check-helper';
import { isSupportPass } from 'config';
import iconHelp from 'assets/icon_help_black.svg';
import Dialog from 'components/dialog';
import refuelingSupport2 from 'assets/refueling-support-2.jpg';
import refuelingSupport3 from 'assets/refueling-support-3.jpg';

import { getHasCheckedServiceInstruction, saveHasCheckedServiceInstruction } from 'service/local-data-provider';
import appLoader from 'distributor/app-loader';
const cx = classnames.bind(styles);

const SettingList = ({ featureData, type }) => {
  const { state: appState } = useAppContext();
  const { hasLicensePlates, hasPayments } = getUserInfo(appState);

  return featureData.map(feature => {
    const isMap = feature.id === 'map';
    const isDisabled = feature.id === 'pass' && !feature.isCompleteSetting;
    const cardClass = cx({
      card: true,
      clickable: !feature.isCompleteSetting || isMap,
      finish:
        isMap &&
        ((type === 'mochipay' && hasPayments && hasLicensePlates) ||
          (type === 'pass' && hasPayments && appState.isMochiPassMember)),
      disabled: isDisabled,
    });

    const Text = () => {
      if (isMap) return feature.content;
      return feature.isCompleteSetting ? feature.content.complete : feature.content.unset;
    };

    const Icon = () => {
      if (isMap) return <img src={feature.icon} alt="icon" />;
      return feature.isCompleteSetting ? (
        <img className={styles.done} src={iconCheck} alt="check" />
      ) : (
        <img src={feature.icon} alt="icon" />
      );
    };

    const Arrow = () => {
      if (isDisabled) return <></>;
      if (isMap) return <img src={iconArrow} alt="arrow" className={styles.arrow} />;
      if (!feature.isCompleteSetting) return <img src={iconArrow} alt="arrow" className={styles.arrow} />;
      return <></>;
    };

    if (type !== 'pass' && feature.id === 'pass') return <></>;
    if ((type === 'pass' || type === 'barcode-payment') && feature.id === 'license-plates') return <></>;

    return (
      <Card key={feature.id} className={cardClass}>
        <div className={styles.text}>
          <Icon />
          <Text />
        </div>
        <Arrow />
      </Card>
    );
  });
};

const CarouselStep = ({ data, isStopped }) => {
  return (
    <div className={styles.step} onClick={data.onClick}>
      <Lottie
        isStopped={isStopped}
        options={{
          loop: data.onClick !== undefined,
          animationData: data.lottie,
        }}
      />
      <span className={styles.desc}>{data.content}</span>
    </div>
  );
};

const ServiceInstruction = () => {
  const [lottiesState, setLottiesState] = useState(() => {
    let arr = [];
    for (let i = 0; i < 4; i++) {
      arr.push('stopped');
    }
    return arr;
  });
  const [carouselIndex, setCarouselIndex] = useState(0);
  const [videoShow, setVideoShow] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const parseSearch = qs.parse(location.search);
  const service = parseSearch.service || 'refueling';
  const [type, setType] = useState(parseSearch.type || 'mochipay');
  const { state: appState, dispatch: appDispatch } = useAppContext();
  const loginState = getLoginState();
  const isUser = loginState === 'user';
  const { hasLicensePlates, hasPayments } = getUserInfo(appState);
  const [dialogShow, setDialogShow] = useState(false);
  const { isUsingLegacyReceiptWording } = appState.bootstraps;
  const hasScanPay = appLoader.configData.mainFeaturesList.includes('barcode-payment');

  useEffect(() => {
    if (service === 'refueling' && !getHasCheckedServiceInstruction()) {
      amplitude.serviceInstruction_refueling_hint_dialog_pageview();
      setDialogShow(true);
      saveHasCheckedServiceInstruction();
    }
  }, []);

  const mapsType = {
    refueling: 'gas_stations',
    parking: 'parkinglots',
  };

  const parkingData = {
    about: '停車',
    name: '停車場',
    type: '麻吉付',
    title: '前往支援停車場',
    carouselItems: [
      {
        lottie: parkingTutorial01,
        content: '前往支援停車場，車牌辨識直接進場，免取票卡。',
      },
      {
        lottie: parkingTutorial02,
        content: '停車中，可在服務首頁即時追蹤停車時數與金額狀態。',
      },
      {
        lottie: parkingTutorial03,
        content: '車牌辨識直接離場，免至繳費機，出場自動完成扣款。',
      },
    ],
  };

  const refuelingData = type => {
    const tabData = {
      mochipay: {
        type: '麻吉付',
        carouselItems: [
          {
            lottie: refuelingTutorial01,
            content: '前往麻吉付支援加油站，加油前與站員說「我要使用麻吉付」與統編。',
          },
          {
            lottie: refuelingTutorial02,
            content: isCathaymr
              ? '等待加油結束，開啟麻吉付網頁等待出現授權付款畫面，點擊「同意付款」完成。'
              : `等待加油結束，手機打開${distributorName()}等待出現「同意付款」畫面，點擊同意完成付款。`,
          },
          {
            lottie: refuelingTutorial03,
            content: isUsingLegacyReceiptWording
              ? '記得索取發票即可離開，將會收到 Email 消費明細。'
              : '加油完成，部分加油站發票自動存入設定載具，現場免拿發票。',
          },
        ],
      },
      pass: {
        type: '快速通',
        carouselItems: [
          {
            lottie: refuelingPassTutorial01,
            content: '加油前，請先申請開通「加油快速通」服務。',
          },
          {
            lottie: refuelingPassTutorial02,
            content: '前往快速通加油站，加油前與站員說「我要使用快速通」。',
          },
          {
            lottie: refuelingPassTutorial03,
            content: isUsingLegacyReceiptWording
              ? '加油結束，記得索取發票即可離開，隔天將會完成扣款並收到 Email 消費明細。'
              : '加油完成，隔日完成扣款。發票自動存入設定載具，現場免拿發票。',
          },
        ],
      },
      'barcode-payment': {
        type: '條碼付',
        carouselItems: [
          {
            lottie: refuelingPassTutorial01,
            content: '前往支援加油站，等待加油完成後，告知站員「使用條碼付款」與統編。',
          },
          {
            lottie: refuelingPassTutorial02,
            content: '出示「條碼付款」畫面，掃描付款條碼與欲存入發票載具條碼，完成付款。',
          },
          {
            lottie: refuelingPassTutorial03,
            content: '發票將存入您掃描的載具，欲開立統編請記得現場索取發票。',
          },
        ],
      },
    };

    return {
      about: '加油',
      name: '加油站',
      title: '前往支援加油站',
      ...tabData[type],
    };
  };

  const currentInstructionData = service === 'parking' ? parkingData : refuelingData(type);

  useEffect(() => {
    amplitude.serviceInstruction_pageview(currentInstructionData.about);
  }, []); //eslint-disable-line

  useEffect(() => {
    setLottiesState(prev => {
      let newLottieState = prev.map((state, key) => {
        if (key > carouselIndex) {
          return 'stopped';
        }
        if (state === 'stopped') {
          // 與當前 carouselIndex 相同時變為 play
          return key === carouselIndex ? 'play' : 'stopped';
        }
        return 'play';
      });

      return newLottieState;
    });
  }, [carouselIndex]);

  const navigateTo = path => {
    const linkToLogin = () => {
      appDispatch({
        type: SHOW_TOAST_MESSAGE,
        payload: '請先登入再繼續',
      });
      history.push(PATH.USER_LOGIN);
    };

    if (isUser) {
      return history.push({
        pathname: path,
        state: { originPath: 'service-instruction', searchName: 'type', searchContent: type },
      });
    } else {
      linkToLogin();
    }
  };

  const paymentPath = () => {
    if (isCpcpay) {
      return PATH.MOCHIPAY_FLOW_CONFIRM;
    }

    if (isNpcpay) {
      return PATH.MOCHIPAY_FLOW_SETTING;
    }

    return PATH.MOCHIPAY_FLOW_CREDIT_CARD;
  };

  const featureData = [
    {
      id: 'pass',
      isCompleteSetting: appState.me?.isMochiPassMember,
      icon: iconTutorial04,
      content: {
        unset: '目前不開放申請麻吉快速通',
        complete: '已開通麻吉快速通',
      },
    },
    {
      id: 'license-plates',
      isCompleteSetting: hasLicensePlates,
      icon: iconTutorial01,
      content: {
        unset: (
          <div
            onClick={() => {
              amplitude.serviceInstruction_plate_onClick(currentInstructionData.about);
              navigateTo(PATH.LICENSE_PLATES_NEW);
            }}
          >
            設定付款車牌
          </div>
        ),
        complete: (
          <div
            onClick={() => {
              amplitude.serviceInstruction_plate_onClick(currentInstructionData.about);
              navigateTo(PATH.LICENSE_PLATES_INDEX);
            }}
          >
            已綁定 {appState.licensePlates.length} 張車牌
          </div>
        ),
      },
    },
    {
      id: 'payment',
      isCompleteSetting: hasPayments,
      icon: iconTutorial02,
      content: {
        unset: (
          <div
            onClick={() => {
              amplitude.serviceInstruction_payment_onClick(currentInstructionData.about);
              navigateTo(paymentPath());
            }}
          >
            設定付款方式
          </div>
        ),
        complete: (
          <div
            className={styles['complete-payment']}
            onClick={() => {
              amplitude.serviceInstruction_payment_onClick(currentInstructionData.about);
              navigateTo(PATH.MOCHIPAY_FLOW_SETTING);
            }}
          >
            <span>付款方式</span>
            <span>
              {appState.me?.currentCreditCard?.bank.shortName} ···· {appState.me?.currentCreditCard?.lastFourCode}
            </span>
          </div>
        ),
      },
    },
    {
      id: 'map',
      icon: iconTutorial03,
      content: (
        <div
          onClick={() => {
            let { about, name } = currentInstructionData;
            amplitude.serviceInstruction_support_onClick(about, name);
            history.push({ pathname: PATH.MAPS, search: `?poi=${mapsType[service]}&payment=${type}` });
          }}
        >
          附近{currentInstructionData.type}
          {currentInstructionData.name}
        </div>
      ),
    },
  ];

  const serviceInstructionClass = cx({
    'service-instruction': true,
    [type]: true,
  });

  const showScanPayClass = cx({
    'show-barcode-payment': true,
    active: hasPayments,
  });

  let list = (() => {
    let supportRefuelingList = [
      {
        key: 'mochipay',
        text: '麻吉付',
      },
      {
        key: 'pass',
        text: '快速通',
      },
    ];

    return hasScanPay
      ? [
          ...supportRefuelingList,
          {
            key: 'barcode-payment',
            text: '條碼付',
          },
        ]
      : supportRefuelingList;
  })();

  const Selector = () => {
    const offset = () => {
      return list.findIndex(x => x.key === type) * 70;
    };

    return (
      <ul className={styles.selector}>
        <div className={styles.active} style={{ transform: `translateX(${offset()}px)` }} />
        {list.map(item => {
          return (
            <li
              key={item.key}
              onClick={() => {
                amplitude.serviceInstruction_refueling_selector_onClick(currentInstructionData.type);
                history.replace(`${PATH.SERVICE_INSTRUCTION}?service=refueling&type=${item.key}`);
                setType(item.key);
              }}
            >
              {item.text}
            </li>
          );
        })}
      </ul>
    );
  };

  return (
    <>
      {service === 'refueling' && (
        <>
          <Dialog
            withClose
            isShow={dialogShow}
            image={list.length === 2 ? refuelingSupport2 : refuelingSupport3}
            title={`加油支援 ${list.length} 種快速付款方式`}
            message={
              <ul className={styles.dialog}>
                <li>
                  麻吉付：喊聲「麻吉付」付款，App <b>點擊確認付款</b>完成。
                </li>
                <li>
                  快速通：喊聲「快速通」付款，<b>加油完成即可離開</b>，隔日完成扣款。（使用前需先完成開通申請）
                </li>
                {hasScanPay && (
                  <li>
                    條碼付：<b>出示條碼</b>給加油員掃描，即可完成扣款。
                  </li>
                )}
              </ul>
            }
            button="我知道了"
            onConfirm={() => setDialogShow(false)}
            onDismiss={() => setDialogShow(false)}
          />

          <div
            className={styles.help}
            onClick={() => {
              amplitude.serviceInstruction_refueling_hint_onClick();
              setDialogShow(true);
            }}
          >
            <img src={iconHelp} alt="help" />
          </div>
        </>
      )}
      <Video videoId={currentInstructionData.videoId} show={videoShow} onClose={() => setVideoShow(false)} />
      <div className={serviceInstructionClass}>
        <div className={styles.intro}>
          <h3>{currentInstructionData.title}</h3>
          {service === 'refueling' && isSupportPass && <div className={styles['selector-container']}>{Selector()}</div>}
          <div className={styles.steps}>
            <Carousel
              onSwipe={index => {
                amplitude.serviceInstruction_tutorial_swipe(
                  currentInstructionData.about,
                  index + 1,
                  currentInstructionData.type
                );
                setCarouselIndex(index);
              }}
              loading={false}
              items={currentInstructionData.carouselItems.map((data, key) => (
                <CarouselStep
                  data={{ ...data, about: currentInstructionData.about }}
                  isStopped={lottiesState[key] === 'stopped'}
                  key={key}
                  index={key}
                />
              ))}
            />
          </div>
        </div>
        <div className={styles.settings}>
          <div className={styles.list}>
            <SettingList featureData={featureData} type={type} />
          </div>
          {type === 'barcode-payment' && (
            <div className={showScanPayClass}>
              <div className={styles.icon}>
                <IconScanPay />
              </div>
              出示條碼付款
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ServiceInstruction;
